var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',{staticClass:"btn-link btn-icon",on:{"click":_vm.onClicked}},[_c('icon',{class:_vm.iconClass,attrs:{"name":_vm.iconValue,"iconset":_vm.iconset}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }